import { deserialize, serialize } from "serializr";
import { NotificationTypes } from "../../../enums/notificationTypes";
import axiosInstance from "../../../interceptor/axiosInstance";
import { ExamSubjectModel, NewExamSubjectModel } from "../../../models/ExamModels/exam.model";
import { PaginationModel } from "../../../models/PaginationModel/pagination.model";
import { EXAM_SUBJECTS_LIST } from "../../../routes/routeConstants/apiRoutes";
import Notification from "../../../shared/components/Notification";

export class ExamSubjectsService {
  static fetchExamSubjects(queryParams: any, onSuccess: Function, onError: Function) {

    return axiosInstance
      .get(EXAM_SUBJECTS_LIST+ queryParams)
      .then((response) => {
          console.log(response)
          const subjectsModel = deserialize(ExamSubjectModel, response.data["exam_subjects"])
          const metaModel = deserialize(PaginationModel, response.data["meta"])
        onSuccess(subjectsModel, metaModel);
      })
      .catch((error) => {
        Notification({ message: "Failed", description: "Unable to fetch the subjects list",type: NotificationTypes.ERROR });
        onError(error)
      });
  }
  static createNewExamSubject(
    data: any,
    onSuccess: Function,
    onError: Function
  ) {
    console.log(data)
    return axiosInstance
    .post(EXAM_SUBJECTS_LIST, data)
    .then(response => {
      onSuccess(response)
    })
    .catch(error => {
      Notification({ message: "Failed", description: "Unable to create new subject",type: NotificationTypes.ERROR });
      onError(error)
    })
  }
  static updateExamSubject (
    id: any,
    data:any,
    onSuccess: Function,
    onError: Function
  ){
    return axiosInstance
    .put(EXAM_SUBJECTS_LIST + `/${id}`, data)
    .then(response => {
      onSuccess(response)
    })
    .catch(error => {
      Notification({ message: "Failed", description: "Unable to update the exam",type: NotificationTypes.ERROR });
      onError(error)

    })
  }
  static deleteExamSubject (
    data: any,
    onSuccess: Function,
    onError: Function
  ) {
    return axiosInstance
    .delete(EXAM_SUBJECTS_LIST + `/${data.subjectId}`)
    .then(response => {
      onSuccess(response)
    })
    .catch(error => {
      Notification({ message: "Failed", description: "Unable to delete the exam",type: NotificationTypes.ERROR });
      onError(error)

    })
  }
}
